import React from "react";
import ReferenceAnchorPlayer from "./ReferenceAnchorPlayer";

const CONSTRUCT_LABELS = {
  overallSeverity: "Overall Severity",
  "global-voice-severity": "Overall Severity",
  roughness: "Roughness",
  breathiness: "Breathiness",
  strain: "Strain",
};

function anchorTourLabel(anchor) {
  if (anchor.role === "normal" && (anchor.constructIds || []).length > 1) return "Shared Normal";
  const construct = CONSTRUCT_LABELS[anchor.constructId] || anchor.constructId;
  return `${construct} — ${anchor.labelKey || anchor.role}`;
}

export default function AnchorTour({ tour, onPlay, onContinue, disabled = false }) {
  if (!tour) return <section className="byce-task__surface" aria-live="polite"><h3>Anchor tour</h3><p>Loading the governed anchor tour…</p></section>;
  return <section className="byce-task__surface byce-anchor-tour" aria-labelledby="anchor-tour-heading">
    <ReferenceAnchorPlayer
      anchors={tour.anchors}
      headingLabel="Anchor tour"
      helpText="Listen to each reference voice once to establish the listening frame for this session."
      getDisplayLabel={anchorTourLabel}
      getAccessibleLabel={(anchor, displayLabel) => `Listen to ${displayLabel}`}
      onReplay={onPlay}
      disabled={disabled}
    />
    <p aria-live="polite">{tour.completed
      ? "Anchor tour complete."
      : `${tour.playedCount} of ${tour.requiredCount} reference voices heard · ${tour.remainingCount} remaining`}</p>
    <ul className="byce-anchor-tour__status" aria-label="Anchor tour progress">
      {tour.anchors.map(anchor => <li key={anchor.anchorId}>
        <span aria-hidden="true">{anchor.played ? "✓" : "○"}</span> {anchorTourLabel(anchor)} — {anchor.played ? "Heard" : "Not yet heard"}
      </li>)}
    </ul>
    <div className="byce-task__actions">
      <button className="app-btn app-btn-secondary" type="button" disabled={!tour.completed || disabled} onClick={onContinue}>Continue to Voice 1</button>
    </div>
  </section>;
}

export { anchorTourLabel };
